/* assets/gcitypartners-project-submit.js — GCITYPARTNERS-PROJECT-SUBMIT-BLK03-03
 * Explicit Review Brief -> canonical customer Project bridge.
 * Draft ownership remains gcitypartners-review-brief-schema.js.
 * Project ownership remains gcity-core-api delivery_jobs via the native GCityPartners facade.
 * GTender handoff data is candidate context only; Core must revalidate it before analytics use.
 */
(function (window, document) {
  'use strict';

  var ROOT = '[data-gcitypartners-page-system][data-review-brief-project-endpoint]';
  var FORM = '[data-enterprise-triage-form][data-gcp-brief-only-form]';
  var API_ORIGIN = 'https://api.glhksolution.com';
  var PROJECT_PATH = '/v1/gcitypartners/commercial/projects/create';
  var GTENDER_HANDOFF_KEY = 'gcp_dashboard_brief_handoff_v1';
  var GTENDER_HANDOFF_MAX_AGE_MS = 30 * 60 * 1000;
  var GTENDER_TENDER_ID_RE = /^[A-Za-z0-9._:-]{3,160}$/;
  var mounted = new WeakSet();
  var SERVICE_THEMES = Object.freeze({
    'service-life-events': true,
    'service-immigration-id': true,
    'service-housing-land': true,
    'service-social-welfare': true,
    'service-government': true,
    'service-health': true,
    'service-recreation-culture': true,
    'service-education-training': true,
    'service-employment': true,
    'service-tax-finance': true,
    'service-trade-commerce': true,
    'service-transport-driving': true,
    'service-utilities': true,
    'service-communications-tech': true,
    'service-cross-boundary': true,
  });
  var allowedFields = [
    'record_id',
    'source',
    'intent',
    'service_lane',
    'service_theme',
    'project_location',
    'project_stage',
    'business_need',
    'description',
    'desired_outcome',
    'asset_access_link',
    'gsd_requirement',
    'project_timeline',
    'budget_range',
    'source_context',
    'source_card_id',
    'source_card_type',
    'resource_mode',
    'resource_type',
    'resource_goals',
    'precheck_type',
    'precheck_version',
    'precheck_score',
    'precheck_purpose',
    'precheck_evidence',
    'precheck_recommendations',
    'csdi_location_name',
    'csdi_location_address',
    'csdi_location_district',
    'csdi_location_x',
    'csdi_location_y',
    'csdi_source',
  ];

  function clean(value) {
    return String(value == null ? '' : value).trim();
  }
  function isZh() {
    return /^zh/i.test(clean(document.documentElement.lang));
  }
  /**
   * @param {string} zh
   * @param {string} en
   */
  function words(zh, en) {
    return isZh() ? zh : en;
  }
  function evidenceFiles(value) {
    var seen = Object.create(null);
    return clean(value)
      .split(/[\n,]+/)
      .map(clean)
      .filter(function (item) {
        if (!item || seen[item]) return false;
        seen[item] = true;
        return true;
      })
      .slice(0, 12);
  }

  /** @param {Element} root */
  function endpoint(root) {
    var raw = clean(root.getAttribute('data-review-brief-project-endpoint'));
    if (!raw) return '';
    try {
      var url = new URL(raw, API_ORIGIN);
      return url.origin === API_ORIGIN && url.pathname === PROJECT_PATH ? url.toString() : '';
    } catch (_error) {
      return '';
    }
  }

  function nativeSession() {
    var session = window.LittleGWebSession;
    return session && typeof session.authenticatedFetch === 'function' ? session : null;
  }

  function makeKey() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return 'gcp-project-' + window.crypto.randomUUID();
    }
    return 'gcp-project-' + Date.now() + '-' + Math.random().toString(36).slice(2);
  }

  function sourceJob() {
    try {
      var value = clean(new URL(window.location.href).searchParams.get('source_job'));
      return /^[A-Za-z0-9._:-]{3,160}$/.test(value) ? value : '';
    } catch (_error) {
      return '';
    }
  }

  function gtenderHandoffTenderId() {
    try {
      var search = new URL(window.location.href).searchParams;
      if (search.get('source') !== 'gtender' || search.get('intent') !== 'professional-review')
        return '';
      var raw = window.sessionStorage.getItem(GTENDER_HANDOFF_KEY);
      if (!raw) return '';
      var value = JSON.parse(raw);
      if (!value || value.version !== 1 || clean(value.source) !== 'gtender') return '';
      var createdAt = Number(value.created_at || 0);
      var age = Date.now() - createdAt;
      if (!Number.isFinite(age) || age < 0 || age > GTENDER_HANDOFF_MAX_AGE_MS) return '';
      var context =
        value.tender_context && typeof value.tender_context === 'object'
          ? value.tender_context
          : {};
      var tenderId = clean(context.id);
      return GTENDER_TENDER_ID_RE.test(tenderId) ? tenderId : '';
    } catch (_error) {
      return '';
    }
  }

  function canonicalServiceTheme(value) {
    var key = clean(value).toLowerCase();
    return SERVICE_THEMES[key] ? key : '';
  }

  function serviceThemeFromLane(value) {
    var owner = window.GCityPartnersServiceLaneMap;
    if (!owner || typeof owner.find !== 'function') return '';
    try {
      var lane = owner.find(value);
      return canonicalServiceTheme(lane && lane.service_theme);
    } catch (_error) {
      return '';
    }
  }

  function projectPayload(form) {
    var data = new FormData(form);
    var payload = {};
    allowedFields.forEach(function (name) {
      var value = clean(data.get(name));
      if (value) payload[name] = value;
    });

    payload.service_theme =
      canonicalServiceTheme(payload.service_theme) || serviceThemeFromLane(payload.service_lane);
    if (!payload.service_theme) delete payload.service_theme;

    var evidence = evidenceFiles(data.get('evidence_files'));
    if (evidence.length) payload.evidence_files = evidence;

    var source = sourceJob();
    if (source) payload.source_job = source;

    var tenderId = gtenderHandoffTenderId();
    if (tenderId) {
      payload.source = 'gtender';
      payload.source_context = 'gtender-opportunity';
      payload.source_card_id = tenderId;
      payload.source_card_type = 'gtender-tender';
    }
    return payload;
  }

  function statusNode(actions) {
    var status = document.createElement('p');
    status.className = 'gcitypartners-page-system__status-line';
    status.setAttribute('data-gcp-project-submit-status', '');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    actions.insertAdjacentElement('afterend', status);
    return status;
  }

  function setStatus(root, status, state, text) {
    root.setAttribute('data-review-brief-project-state', state);
    status.textContent = text || '';
  }

  function createButton(actions) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'gcp-btn';
    button.setAttribute('data-gcp-create-project', '');
    button.textContent = words('建立項目需求記錄', 'Create project request');
    actions.appendChild(button);
    return button;
  }

  async function createProject(root, form, button, status) {
    if (button.disabled) return;
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
      if (typeof form.reportValidity === 'function') form.reportValidity();
      setStatus(
        root,
        status,
        'invalid',
        words('請先完成必填的 Project Brief。', 'Complete the required Project Brief fields first.')
      );
      return;
    }

    var url = endpoint(root);
    if (!url) {
      setStatus(
        root,
        status,
        'unavailable',
        words('Project 建立入口未配置。', 'Project creation is not configured.')
      );
      return;
    }

    var session = nativeSession();
    if (!session) {
      setStatus(
        root,
        status,
        'auth-required',
        words(
          '請先登入產品帳戶，再建立 Project。',
          'Sign in to your product account before creating a Project.'
        )
      );
      return;
    }

    var key = clean(form.dataset.gcpProjectIdempotencyKey) || makeKey();
    form.dataset.gcpProjectIdempotencyKey = key;
    button.disabled = true;
    setStatus(root, status, 'submitting', words('正在建立 Project…', 'Creating Project…'));

    try {
      const submittedPayload = projectPayload(form);
      var response = await session.authenticatedFetch(url, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Idempotency-Key': key,
        },
        body: JSON.stringify(submittedPayload),
      });
      var payload = await response.json().catch(function () {
        return {};
      });

      if (!response.ok || !payload || payload.ok !== true) {
        var error = new Error(
          clean(payload && payload.error) ||
            clean(payload && payload.message) ||
            'request_' + response.status
        );
        error.status = response.status;
        error.serverMessage = clean(payload && payload.message);
        throw error;
      }

      var jobId = clean(payload.job_id);
      if (!jobId) throw new Error('missing_project_job_id');

      var formalStatus = form.elements.formal_submission_status;
      if (formalStatus) formalStatus.value = 'project_created';
      form.dataset.gcpProjectJobId = jobId;
      root.setAttribute('data-review-brief-project-id', jobId);
      const returnedStatus = clean(payload.status);
      const statusMessage = returnedStatus
        ? words('後端返回狀態：' + returnedStatus + '。', 'Backend status: ' + returnedStatus + '.')
        : words('後端未提供業務狀態。', 'The backend did not provide a business status.');

      setStatus(
        root,
        status,
        'created',
        words('項目記錄已建立（' + jobId + '）。', 'Project record created (' + jobId + '). ') +
          statusMessage +
          words(
            '建立記錄本身不代表 Provider 已受理、接受任務或完成專業審核。',
            'Creating the record does not itself confirm Provider intake, task acceptance or professional review.'
          )
      );
      button.textContent = words('項目記錄已建立', 'Project record created');
      button.disabled = true;
    } catch (error) {
      var httpStatus = Number(error && error.status);
      var code = clean(error && error.message);
      var message =
        httpStatus === 401 || httpStatus === 403
          ? words(
              '登入狀態已失效或沒有存取權限，請重新登入後再試。',
              'Your sign-in or access is no longer valid. Sign in again and retry.'
            )
          : code === 'source_job_not_completed'
            ? words(
                '後續 Project 只能從已完成的原 Project 建立。',
                'A follow-on Project requires a completed source Project.'
              )
            : code === 'source_job_not_found'
              ? words(
                  '找不到可用的原 Project，請重新整理後再試。',
                  'The source Project is unavailable. Refresh and try again.'
                )
              : httpStatus === 409
                ? words(
                    'Project 內容與先前提交不一致，請重新整理後再試。',
                    'The Project request conflicts with an earlier submission. Refresh and try again.'
                  )
                : code === 'native_session_unavailable'
                  ? words(
                      '請先登入產品帳戶，再建立 Project。',
                      'Sign in to your product account before creating a Project.'
                    )
                  : words(
                      '暫時無法建立 Project。請檢查草稿是否已儲存；未儲存的資料請先保留。',
                      'Project creation is temporarily unavailable. Check whether your draft was saved; keep any unsaved details before leaving.'
                    );
      setStatus(root, status, 'error', message);
      button.disabled = false;
    }
  }

  function mount(root) {
    if (!root || mounted.has(root)) return;
    var form = root.querySelector(FORM);
    var actions = form && form.querySelector('.gcp-actions');
    if (!form || !actions) return;
    mounted.add(root);

    var button = createButton(actions);
    var status = statusNode(actions);
    root.setAttribute('data-review-brief-project-state', 'ready');

    button.addEventListener('click', function () {
      void createProject(root, form, button, status);
    });

    function markPostCreationEdits() {
      if (form.dataset.gcpProjectJobId) {
        root.setAttribute('data-review-brief-project-edited-after-create', 'true');
        setStatus(
          root,
          status,
          'created',
          words(
            'Project 已建立，但目前修改的資料尚未同步到該 Project；請勿重複建立。',
            'Project created. Your latest edits are not synchronized to that Project; do not create a duplicate.'
          )
        );
        return;
      }
      delete form.dataset.gcpProjectIdempotencyKey;
    }
    form.addEventListener('input', markPostCreationEdits);
    form.addEventListener('change', markPostCreationEdits);
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll(ROOT), mount);
  }

  // Shopify theme editor re-renders sections without a full page navigation.
  // mount() already guards each live root via WeakSet.
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})(window, document);
